export default "__VITE_ASSET__df38d95c__"